export default __webpack_public_path__ + "static/media/light-bulb.ad56c5cc.svg";